import axios from "axios";
import API from "../helpers/endpointService";
import {warningAlert,successAlert} from "../components/custom/alert"
import { successToast, errorToast, deleteToast } from "./CommonFunction";
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {toast} from "react-toastify";  

toast.configure();
//Vessel Particular API
let UpdateResult = {
  SummaryUp: "",
  ShortUp: "",
  DetailedUp: ""
}

export const filedeleteimage = (id, name) => {
  let apiUrl = `${API.Delete_images}?id=${id}&image=${name}`;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "SHOW_LOADER", data: false })
          // successAlert("Deleted successfully.");
          deleteToast();
        } else {
          dispatch({ type: "SHOW_LOADER", data: false })
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
         // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const putDetailedSummaryDesc = (data, id) => {
  let apiUrl = `${API.AddEdit_Richtext}?id=${id}`;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "SHOW_LOADER", data: false })
          UpdateResult.DetailedUp = response?.data;
        } else {

        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
         // warningAlert("Something went wrong. Please try again.");
       errorToast();
       this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) { }
      });
  }
}
export const putShortSummaryDesc = (data, id) => {
  let apiUrl = `${API.AddEdit_Richtext}?id=${id}`;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          UpdateResult.ShortUp = response?.data;          
        } else {
        }
        dispatch({ type: "SHOW_LOADER", data: false });
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) { }
      });
  }
}



// export const putShipSummaryInfo = (data, id) => {  
//  
//   let apiUrl = `${API.AddEdit_Inspection}?id=${id}`;
//   return (dispatch) => {
//     //
//     dispatch({ type: "SHOW_LOADER", data: true })
//     axios({
//       method: "POST",
//       url: apiUrl,
//       data: data,
//     })
//       .then((response) => {
//         dispatch({ type: "SHOW_LOADER", data: false })
//         if (response?.status === 200) {
//           UpdateResult.SummaryUp = response?.data;
//           if (UpdateResult.SummaryUp !== "" && UpdateResult.ShortUp != "" && UpdateResult.DetailedUp != "") {
//             //successToast();
//             debugger;
//             
//            navigate('/inspection/operationaldata');//           
//           }
//         } else {

//         }
//       })
//       .catch((error) => {
//         debugger;
//         dispatch({ type: "SHOW_LOADER", data: false })
//          // warningAlert("Something went wrong. Please try again.");
//        errorToast();
//         dispatch({ type: "CANCEL", data: true });
//         if (error?.response?.status === 401) { }
//       });
//   }
// };

 
export const PutShipSummaryInfo =  ({data, id, putData}) => {  

     const navigate = useNavigate(); 
     const dispatch = useDispatch();       

     useEffect(() =>  {
     let apiUrl = `${API.AddEdit_Inspection}?id=${id}`;
     dispatch({ type: "SHOW_LOADER", data: true })
     if(putData === true)
     {
      console.log("Api: " + apiUrl);
        axios({
        method: "POST",
        url: apiUrl,
        data: data,
      })
        .then((response) => {
          dispatch({ type: "SHOW_LOADER", data: false })
          if (response?.status === 200) {
            UpdateResult.SummaryUp = response?.data;
            if (UpdateResult.SummaryUp !== "" && UpdateResult.ShortUp != "" && UpdateResult.DetailedUp != "") {
              
              successToast();              
             setTimeout(() => {
              navigate('/inspection/operationaldata');
            }, 2000);             
            }
             
          } else {
  
          }
        })
        .catch((error) => {          
          dispatch({ type: "SHOW_LOADER", data: false })
            // warningAlert("Something went wrong. Please try again.");
          errorToast();
          dispatch({ type: "CANCEL", data: true });
          if (error?.response?.status === 401) { }
        });
        }
    },[putData]);
    return(<></>);
  };